import { request } from "../../utils/config"

export const GET_MUSICS = async () => {
  const response = await request({
    url: `Musics`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_MUSIC = async (id) => {
  const response = await request({
    url: `Musics/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
